import React, { Component } from 'react';

class SettingFooterPage extends Component {
  	render(){
		return (
			<div>
				<h3>Footer</h3>
			</div>
		)
	}
}

export default SettingFooterPage;


// WEBPACK FOOTER //
// ./src/pages/settings/SettingFooterPage.js